// @ts-nocheck

import { INVOICES } from '../actions/SubscriptionActions';
import { reducerWrapper } from '../support/utils';
import type { InvoicesReducer } from '../types/invoicesTypes';
var INIT_STATE: InvoicesReducer = {
  loading: false,
  error: null,
  data: {
    invoices: [],
  },
};

function Handler(state: InvoicesReducer, action) {
  let { data } = action;

  switch (action.type) {
    case INVOICES.response:
      data = data || {};
      return Object.assign({}, state, {
        loading: false,
        data,
      });

    default:
      return state;
  }
}

const Invoices = reducerWrapper(INIT_STATE, Handler, {
  request: [INVOICES],
  error: [INVOICES],
  resetOn: ['APP_CHANGE'],
});
export default Invoices;
